import AppRouter from './router/AppRouter';
import './App.css';

export default function App() {
  return <AppRouter />;
}